import styled from "styled-components";
import colors from "assets/scss/colors.scss";

const StyleWrapper = styled.div`
  .policy-detail {
    .policy-box {
      padding: 24px;
      background: #f2f3f5;
      border-bottom: 2px solid #f2f3f5;
      border-radius: 8px;
      .policy-row {
        margin: 0 0 20px;
        .p-calendar {
          width: 100%;
          box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
          border-radius: 4px;
          input {
            font-family: "tawuniya";
          }
        }
        .p-button:enabled:hover,
        .p-button:not(button):not(a):not(.p-disabled):hover {
          background: #fff;
          color: #6b47f5;
          border: none;
        }
        .p-button {
          color: #6b47f5;
          background: #fff;
          border: none;
        }
        .p-inputtext:enabled:focus {
          box-shadow: none;
          border: none;
        }
        .p-inputtext {
          border: none;
          height: 54px;
          padding: 16px;
        }
        .pi {
          font-size: 1.3rem;
        }
        .p-inputgroup {
          box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
          border-radius: 4px;
          background: none;
        }
        .p-inputgroup-addon:last-child {
          border: none;
        }
        .p-inputgroup-addon {
          background: #f2f3f5;
        }
        .p-dropdown {
          width: 100%;
          box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
          border-radius: 4px;
          border: none;
          font-weight: 700;
          font-size: 1rem;
          color: #4c565c;
        }
        .p-float-label .p-inputwrapper-focus ~ label,
        .p-float-label .p-inputwrapper-filled ~ label {
          top: 0.8rem;
          font-size: 0.7rem;
          color: #676f7c;
        }
        .p-button:focus {
          box-shadow: none;
        }
        .p-calendar-w-btn-left .p-datepicker-trigger {
          border: none;
          // border-radius: 0;
        }
      }
      .apply-all {
        display: flex;
        margin-top: 25px;
      }
      .p-inputswitch {
        margin: 0 10px;
      }
      .p-inputswitch.p-focus .p-inputswitch-slider {
        box-shadow: none;
      }
      .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
        background: ${colors["bright-purple"]};
      }
    }
  }

  .policy-detail.ar {
    .p-float-label > label {
      right: 0.75rem;
      left: auto;
    }
  }

  .motor-drive {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    margin-top: 20px;
  }

  .motor-drive-2 {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 12px;
  }

  .motor-drive-2 input[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    background-color: #D9DCE1;
    margin: 0;
    color: white;
    width: 20px;
    min-width: 20px;
    height: 20px;
    border: none;
    border-radius: 0.15em;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
  }

  .motor-drive-2 input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: #FFFFFF;
    color: #6B47F5;
  }

  .motor-drive-2 input:checked {
    background-color: #6B47F5 !important;
  }

  .motor-drive-2 input[type="checkbox"]:checked::before {
    transform: scale(1);
  }

  .motor-drive-2 input[type="checkbox"]:disabled {
    --form-control-color: var(--form-control-disabled);
  
    color: var(--form-control-disabled);
    cursor: not-allowed;
  }

  .red-inception{
    border:1px solid red
  }
  .normal-inception{
    border:1px solid #6B47F5
  }

  .motor-drive-title {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 160%;
    display: flex;
    align-items: center;
    color: #455560;
    span, a {
      color: #6B47F5 !important;
      text-decoration: none;
    }
  }

  @media only screen and (max-width: 980px) {
    .apply-all label {
      width: 75%;
    }
  }
  @media only screen and (max-width: 575.99px) {
    .policy-box {
      padding: 0 !important;
    }
    .policy-detail .policy-box .policy-row {
      margin: 0 0 0;
    }
    .policy-detail .policy-box .policy-row .columnpolicy {
      // margin-bottom: 15px;
    }
  }
`;
export default StyleWrapper;
